import React from 'react';
import MenuLink from './MenuLink';
import AccordionSubMenu from './AccordionSubMenu';
import { StyledMenuItem } from './StyledMenuComponents';
export default function BeneficiariesMenu({ bankStatus, investStatus, isBank, isInvest, routeInEmber, routeLinks, hasTrusteeOnlyAccounts, hasNoAccounts, hasOpenDepositAccounts, closeMenu, closeAccordion, activeAccordion, updateAccordionState, }) {
    const isBoth = isBank && isInvest;
    const isBankDown = bankStatus === 'down';
    const isInvestDown = investStatus === 'down';
    const shouldRender = !isBankDown || !isInvestDown;
    const shouldRenderBankLink = isBank && !isBankDown && !hasTrusteeOnlyAccounts && hasOpenDepositAccounts;
    const shouldRenderInvestLink = isInvest && !isInvestDown && !hasNoAccounts;
    if (!shouldRender) {
        return React.createElement(React.Fragment, null);
    }
    if (isBoth) {
        return (React.createElement(AccordionSubMenu, { accordionId: "beneficiaries", shouldRenderBankLink: shouldRenderBankLink, shouldRenderInvestLink: shouldRenderInvestLink, instanceKey: "beneficiaries-submenu", title: "Beneficiaries", ariaLabel: "Beneficiaries", linkInfo: routeLinks.beneficiaries, routeInEmber: routeInEmber, closeMenu: closeMenu, closeAccordion: closeAccordion, activeAccordion: activeAccordion, updateAccordionState: updateAccordionState }));
    }
    if (shouldRenderBankLink) {
        return (React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.beneficiaries.bankUrl, text: routeLinks.beneficiaries.content, routeInEmber: routeInEmber, closeMenu: closeMenu })));
    }
    if (shouldRenderInvestLink) {
        return (React.createElement(StyledMenuItem, null,
            React.createElement(MenuLink, { to: routeLinks.beneficiaries.investUrl, text: routeLinks.beneficiaries.content, routeInEmber: routeInEmber, closeMenu: closeMenu })));
    }
    return React.createElement(React.Fragment, null);
}
//# sourceMappingURL=BeneficiariesMenu.js.map